import { render, staticRenderFns } from "./PressCoralClub.vue?vue&type=template&id=15feb1a9&scoped=true&"
import script from "./PressCoralClub.vue?vue&type=script&lang=js&"
export * from "./PressCoralClub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15feb1a9",
  null
  
)

export default component.exports